import React from 'react';
import { motion } from 'framer-motion';

const AppShell = ({ appId, appLabel, onClose, children }) => {
  return (
    <motion.div
      key={appId}
      initial={{ y: '100%' }}
      animate={{ y: 0 }}
      exit={{ y: '100%' }}
      transition={{ type: 'spring', damping: 30, stiffness: 300 }}
      className="fixed inset-x-0 bottom-0 z-[55] bg-pure-black overflow-y-auto"
      style={{ top: '32px' }}
    >
      {/* App Header */}
      <div className="sticky top-0 z-10 bg-pure-black/80 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
          <motion.button
            whileHover={{ x: -3 }}
            whileTap={{ scale: 0.95 }}
            onClick={onClose}
            className="flex items-center gap-1.5 text-apple-blue font-medium text-sm shrink-0"
          >
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 1L1 7L7 13"
                stroke="#007AFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Home
          </motion.button>

          <h2 className="text-pure-white font-semibold text-lg">{appLabel}</h2>
        </div>
      </div>

      {/* App Content */}
      <div className="pb-16">{children}</div>

      {/* Home Indicator */}
      <div className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[56]">
        <div className="w-32 h-1 bg-white/20 rounded-full" />
      </div>
    </motion.div>
  );
};

export default AppShell;
